// Excavation needs a browser board and an atomic loot/degradation verdict.
import { refuseUnported } from '../janus-engine/unported';

async function openDigUncoverPanel(digsiteInventoryId: string): Promise<void> {
    refuseUnported('excavation:board-and-loot-save-not-ported', { inventoryId: digsiteInventoryId });
}
window.openDigUncoverPanel = openDigUncoverPanel;
